import styled from 'styled-components';


export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${props => props.theme.white1};
  height: 100vh;
`;
export const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  margin-left: 0;
`;

export const MainContainer = styled.div`
  display: flex;
  @media (max-width: 1440px) {
    display: block;
  }
`;

export const ModifyContainer = styled.div`
  min-width: 1000px;
  width: 100%;
  background-color: ${props => props.theme.white1};
  position: relative;
  border: 1px solid ${props => props.theme.white4};
  margin: 20px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;
export const SearchContainer = styled.div`
  border: 1px solid ${props => props.theme.white1};
  background: ${props => props.theme.white2};
  color: unset;
  border-radius: 10px;
  display: flex;
  padding: 5px 10px;
  align-items: center;
`;
export const Input = styled.input`
  width: 200px;
  height: 28px;
  padding: 0 10px;
  margin: 5px;
  border-radius: 5px;
  border: 0;
  background-color: ${props => props.theme.white0};
  color: unset;

  &.date {
    width: 120px;
  }

  /* Chrome, Safari, Edge, Opera */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;
  appearance: none;

  &:focus {
    outline: none;
  }
`;

export const SelectContainer = styled.select`
  width: 150px;
  height: 28px;
  margin: 5px;
  padding: 0 10px;
  border-radius: 5px;
  border: 0;
  background-color: ${props => props.theme.white0};
  color: unset;

  &:focus {
    outline: none;
  }
`;

export const ButtonContainer = styled.button`
  width: 100px;
  height: 28px;
  margin: 5px;
  border-radius: 5px;
  border: 0;
  background-color: ${props => props.theme.white3};
  color: unset;
  &:focus {
    outline: none;
  }
  &:hover {
  background-color: ${props => props.theme.white5};
  }
`;

export const TableContainer = styled.div`
  margin-top: 20px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.th`
  border: 1px solid ${props => props.theme.white5};;
  padding: 15px;
  text-align: center;
`;

export const TableData = styled.td`
  border: 1px solid ${props => props.theme.white5};
  padding: 5px;
  text-align: center;
`;